
import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from './components/DashboardLayout';
import MainDashboard from './components/MainDashboard';
import SingleEntry from './components/SingleEntry';
import BulkUpload from './components/BulkUpload';
import Settings from './components/Settings';
import History from './components/History';
import { ErrorBoundary } from './components/ErrorBoundary';
import { idleRedirect } from './services/env';

const App: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const saved = localStorage.getItem('reachai_theme');
    if (saved) return saved === 'dark';
    // Check system preference if no saved preference
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  useEffect(() => {
    // Apply theme globally
    if (isDarkMode) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('reachai_theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('reachai_theme', 'light');
    }
  }, [isDarkMode]);

  useEffect(() => {
    // App is ready since Cloudflare Zero Trust handles authentication
    setIsLoading(false);
  }, []);
  useEffect(() => {
    if (!idleRedirect.enabled) return;
    const timer = setTimeout(() => {
      window.location.href = idleRedirect.url;
    }, idleRedirect.ms);
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-slate-50 dark:bg-slate-950 transition-colors">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  return (
    <ErrorBoundary>
    <Router>
      <Routes>
        <Route 
          path="/" 
          element={<DashboardLayout />}
        >
          <Route index element={<MainDashboard />} />
          <Route path="single" element={<SingleEntry />} />
          <Route path="bulk" element={<BulkUpload />} />
          <Route path="history" element={<History />} />
          <Route path="settings" element={<Settings />} />
        </Route>
        
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
    </ErrorBoundary>
  );
};

export default App;
